import { Routes } from "@angular/router";
import { SignInRedirectComponent } from "./pages/sign-in/sign-in-redirect.component";
import { SignInComponent } from "./pages/sign-in/sign-in.component";
import { SignUpComponent } from "./pages/sign-up/sign-up.component";
import { AppUnauthenticatedLayoutComponent } from "../../shared/ui/apollo-template/components/app-unauthenticated-layout";

export const SignInRoutes: Routes = [
  {
    path: "",
    children: [
      {
        path: "signIn",
        component: AppUnauthenticatedLayoutComponent,
        children: [{ path: "", component: SignInComponent, title: "app.sign-in.title" }],
      },
      {
        path: "signUp",
        component: AppUnauthenticatedLayoutComponent,
        children: [{ path: "", component: SignUpComponent, title: "app.sign-up.title" }],
      },
      { path: "signInRedirect", component: SignInRedirectComponent, title: "app.sign-in-redirect.title" },
      {
        path: "kohoSignIn",
        loadComponent: () => import("./pages/koho-sign-in/koho-sign-in.component").then((c) => c.KohoSignInComponent),
      },
      {
        path: "kohoSsoRedirect",
        loadComponent: () =>
          import("./pages/koho-sign-in/koho-sso-redirect.component").then((c) => c.KohoSsoRedirectComponent),
      },
    ],
  },
];
